import ContentContainer from "components/ContentContainer";
import FullPageContainer from "components/FullPageContainer";
import { Search } from "iparque-components";
import styled from "styled-components";
import { breakpoints } from "theme/breakpoints";

export const StyledFullPageContainer = styled(FullPageContainer)`
  background-color: ${({ theme }) => theme.background.color};
`;

export const StyledContentContainer = styled(ContentContainer)`
  box-sizing: border-box;
  width: 80%;
  margin-top: 80px;
  margin-bottom: 20px;
  justify-content: flex-start;

  // IE
  @media all and (-ms-high-contrast: none) {
    flex: none;
  }
`;

export const InnerContainer = styled.div`
  width: 45%;
  min-width: 600px;
  display: flex;
  flex-direction: column;

  .scroll-padding {
    padding-right: 10px;
  }

  @media (max-width: ${breakpoints.lg}) {
    width: unset;
    min-width: unset;
  }
`;

export const StyledSearch = styled(Search)`
  // IE
  @media all and (-ms-high-contrast: none) {
    svg {
      top: 7px;
    }
  }
`;
